import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  SectionContainerBase,
  TwoColumnSectionBase,
  SidebarBase,
  NavigationBase,
  FooterBase,
  ButtonBase,
} from "@reusejs/react";
import Logo from "../header/Logo";
import { useSelector, useDispatch } from "react-redux";
import { clearBidderAuth } from "store";
import LeftNavButtons from "./NavButtons";
import RightNavButtons from "./rightNavButtons";
import BidderSidebar from "./bidderSidebar";
import {
  HomeIcon,
  CalendarIcon,
  OfficeBuildingIcon,
  DocumentTextIcon,
  IdentificationIcon,
  LogoutIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/outline";

const BidderDashboardLayout = ({ children }: any) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const userAttributes = useSelector((state: any) => {
    const attributes = state.bidderAuth?.user?.attributes;
    const mobile = attributes?.find(
      (attr: any) => attr.type === "mobile_number"
    );
    const email = attributes?.find((attr: any) => attr.type === "email");
    return { email: email?.value, mobile: mobile?.value };
  });

  const bidderOnboarding = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const [navigation, setNavigation] = useState([
    {
      label: "Home",
      href: "/",
      icon: HomeIcon,
      current: false,
    },
    {
      label: "Auction Events",
      href: "/auction-events",
      icon: CalendarIcon,
      current: false,
    },
    {
      label: "Auction Properties",
      href: "/properties",
      icon: OfficeBuildingIcon,
      current: false,
    },
    {
      label: "KYC",
      href: "/kyc",
      icon: IdentificationIcon,
      current: false,
    },
    {
      label: "Documents",
      href: "/documents",
      icon: DocumentTextIcon,
      current: false,
    },
  ]);

  useEffect(() => {
    setNavigation((prev: any) => {
      let next = prev.map((element: any) => {
        if (element.children) {
          let children = element.children.map((child: any) => {
            child.current = child.href === router.asPath ? true : false;
            return child;
          });
          element.children = children;
        }

        element.current = element.href === router.asPath ? true : false;
        return element;
      });

      return next;
    });
  }, [router]);

  const handleLogout = () => {
    dispatch(clearBidderAuth());
    router.push(`${process.env.NEXT_PUBLIC_WEB_URL}logout`);
  };
  return (
    <>
      <div className="min-h-screen">
        <SectionContainerBase
          sectionContainerBaseClasses={{
            outerContainerStyles: "bg-white overflow-hidden",
            innerContainerStyles: "relative",
          }}
        >
          <TwoColumnSectionBase
            firstColumnEl={
              <>
                <SidebarBase
                  navigationItems={navigation}
                  topItem={<Logo />}
                  onClick={(e: any, item: any) => {
                    if (process.env.NEXT_PUBLIC_ENABLE_FEATURE === "true") {
                      if (bidderOnboarding?.status === "active") {
                        router.push(item.href, undefined, { shallow: true });
                      }
                    } else {
                      router.push(item.href, undefined, { shallow: true });
                    }
                  }}
                />
                <div className="border-t h-18 w-64 flex flex-col px-6 py-2 items-center absolute bottom-0 left-0">
                  <div className="text-gray-400 mb-2">
                    {userAttributes && userAttributes?.email
                      ? userAttributes?.email
                      : userAttributes?.mobile}
                  </div>
                  <ButtonBase
                    variant="primary"
                    type="submit"
                    label="Logout"
                    onClick={() => handleLogout()}
                    buttonPrefix={
                      <LogoutIcon
                        height="16"
                        width="16"
                        className="rotate-180 mr-2"
                      />
                    }
                    buttonBaseClasses={{
                      font: "text-sm font-medium",
                      backgroundColor: "bg-blue-600 hover:bg-blue-700",
                      textColor: "text-white",
                      border: "any",
                      width: "sm:w-full",
                      padding: "px-2 py-2",
                    }}
                  />
                </div>
              </>
            }
            secondColumnEl={
              <div className="flex flex-col">
                <NavigationBase
                  left={LeftNavButtons}
                  middle={Logo}
                  right={RightNavButtons}
                  sidebar={BidderSidebar}
                  backgroundClasses="bg-white fixed top-0 z-20 left-0 sm:left-64 right-0 dark:bg-[#12263f] "
                  widthClasses="mx-auto w-full px-6"
                  leftArrangement="sm:hidden"
                  middleArrangement="w-full justify-center sm:hidden"
                  rightArrangement="flex-1 justify-end"
                  borderClasses="relative border-b border-gray-200 dark:border-blue-800"
                />
                <div className="bg-white w-full pt-16 dark:bg-[#12263f]">
                  {children}
                </div>
                <FooterBase
                  bottom={() => {
                    return (
                      <p className="text-base text-gray-400 text-center">
                        &copy; 2022 Auction Bazaar pvt. ltd. All rights
                        reserved.
                      </p>
                    );
                  }}
                  backgroundClasses="bg-white dark:bg-[#12263f]"
                  widthClasses="none"
                  bottomArrangement="py-1 border-t border-gray-200 dark:border-blue-800"
                />
              </div>
            }
            twoColumnSectionBaseClasses={{
              firstElWrapperStyles:
                "hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 bg-green-100",
              secondElWrapperStyles:
                "w-full self-stretch overflow-scroll md:pl-64",
              columnsFlexWrapperStyles:
                "flex items-start justify-between flex-col md:flex-row",
            }}
          />
        </SectionContainerBase>
      </div>
    </>
  );
};

export default BidderDashboardLayout;
